module.exports = __webpack_public_path__ + "img/quit_icon.f054e5d9.svg";